class StickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-sticky-buy]');
    this.target = document.querySelector('add-to-cart-component button, .product-form__buttons button, [data-add-to-cart]');
    if (!this.target) return;

    this.hidden = false;
    this.trigger?.addEventListener('click', this.jumpToBuyButton);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting);
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.trigger?.removeEventListener('click', this.jumpToBuyButton);
  }

  jumpToBuyButton = () => {
    this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.target.focus({ preventScroll: true });
  };
}

if (!customElements.get('sticky-buy-bar')) {
  customElements.define('sticky-buy-bar', StickyBuyBar);
}
